module.exports = __webpack_public_path__ + "img/transparent-color-icon-256.7963b11c.png";